import * as React from "react";

type Props = {
    html?: string;
    style?: React.CSSProperties;
};

export default ({ html, style }: Props) => {
    if (!html) {
        return null;
    }

    return <div style={style} dangerouslySetInnerHTML={{ __html: html }} />;
};
